<template>
    <div>
      <div class="container p-0">
        <b-card no-body header-text-variant="dark">
          <div slot="header">
            <context-header
              :title="$t('invoices.invoiceReview')"
              :tab="namedTab">
            </context-header>
          </div>
          <b-tabs card lazy pills ref="tabs" v-model="tabIndex" class="test-class" variant="danger" v-on:input="tabChanged()">
            <b-tab :title="headers[0].title" v-if="!isAdmin">
              <creditor-invoices />
            </b-tab>
            <b-tab :title="headers[1].title" v-if="!isAdmin">
              <debtor-invoices/>
            </b-tab>
            <b-tab :title="headers[2].title" v-else>
              <admin-invoices/>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
</template>

<script>
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import CreditorInvoices from './sides/CreditorInvoices'
  import DebtorInvoices from './sides/DebtorInvoices'
  import AdminInvoices from './sides/AdminInvoices'
  import { hasAdminClaim, hasInvoiceReviewAllClaim } from '@/router/auth'

  export default {
    name: 'invoices',
    components: {
      ContextHeader,
      CreditorInvoices,
      DebtorInvoices,
      AdminInvoices
    },
    data () {
      return {
        isAdmin: false,
        headers: [
          { title: this.$t('invoices.invoicesAsCreditor'), value: 'creditor', help_value: 'list' },
          { title: this.$t('invoices.invoicesAsDebtor'), value: 'debtor', help_value: 'list' },
          { title: this.$t('invoices.invoicesAsAdministrator'), value: 'all', help_value: 'list-admin' }
        ],
        query: {},
        tabIndex: 0,
        namedTab: '',
        stateTab: ''
      }
    },
    watch: {
      '$route.query.side' () {
        this.setInvoiceSide()
      }
      // '$route.query' (event) {
      //   this.handleQueryFilterChange(event)
      // }
    },
    created () {
      this.isAdmin = hasAdminClaim() || hasInvoiceReviewAllClaim()
    },
    mounted () {
      this.setInvoiceSide()
    },
    methods: {
      setInvoiceSide () {
        let side = this.$route.query.side
        let header = null
        if (side && side.length > 0) {
          header = this.getTabValue(side)
          this.changeTabState(this, this.$refs, side)
        } else {
          let state = this.loadTabState(this.$route.path)
          if (state && state.length > 0) {
            header = this.getTabValue(state)
            // Go to route
            this.$router.push({path: this.$route.path, query: { ...this.$route.query, side: state }})
          } else {
            header = this.getTabHeader(0)
            this.changeTabState(this, this.$refs, header.value)
          }
        }
        this.namedTab = header.help_value
      },
      tabChanged () {
        let header = this.getTabHeader(this.tabIndex)
        if (header) {
          const param = header.value

          // Save to cookie
          this.saveTabState(this.$route.path, param)
          this.$router.push({path: this.$route.path, query: { ...this.$route.query, side: param }})
        }
      },
      getTabValue (value) {
        for (let i = 0; i < this.headers.length; i++) {
          if (this.headers[i].value.localeCompare(value) === 0) {
            return this.headers[i]
          }
        }
      }
    }
  }

</script>

<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .bg-primary {
    background-color: $primary-color-accent !important;
  }

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

  #cancelInvoicesModal {
    margin-top: 85px !important;
  }

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }

</style>



// WEBPACK FOOTER //
// Invoices.vue?32222a73